import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.avif";
// eslint-disable-next-line no-restricted-imports
import { height, width } from "./header_image.avif?as=metadata:height;width";
// eslint-disable-next-line no-restricted-imports
import headerImageSrcset from "./header_image.avif?w=480;960;1920&format=avif&as=srcset";

export const frontmatter: BlogFrontmatter = {
  title: "Bakom kulisserna i Controlas cyberrisk‑modell",
  header: "Bakom kulisserna i Controlas cyberrisk‑modell",
  date: "2025-11-13",
  description:
    "Hur Controla använder bayesianska nätverk, sannolikhetsfördelningar och Monte Carlo‑simuleringar för att översätta cyberrisk till tydliga kronor och ören.",
  category: "säkerhet",
  draft: false,
  authorKey: "niklas_volcz",
  headerImage,
  headerImageSrcset,
  headerImageDimensions: {
    height,
    width,
  },
};
